import type { ReactNode } from 'react'

export function AuthShell({
  title,
  subtitle,
  children,
}: {
  title: string
  subtitle: string
  children: ReactNode
}) {
  return (
    <main className="grid min-h-svh place-items-center bg-[#fbfaf6] p-4">
      <section className="w-full max-w-md rounded-xl border border-stone-200 bg-white p-6 shadow-sm">
        <div className="mb-6 flex items-center gap-3">
          <div className="grid h-12 w-12 place-items-center rounded-xl bg-mango-yellow/30 font-bold text-leaf-dark">S</div>
          <div>
            <h1 className="text-xl font-bold text-leaf-dark">{title}</h1>
            <p className="text-sm text-stone-500">{subtitle}</p>
          </div>
        </div>
        {children}
      </section>
    </main>
  )
}
